export default "__VITE_ASSET__DJXXR1dt__"